import { AMO_STATUS, AMO_STATUS_ERROR_DATA, AMO_STATUS_HIDE_ERROR_DATA, AMO_STATUS_START_LOADER, AMO_STATUS_STOP_LOADER, } from "../interface/IAMOStatus";
const initState = {
    data: {
        status: false,
    },
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const AMOStatus = (state = initState, action) => {
    switch (action.type) {
        case AMO_STATUS: {
            return Object.assign(Object.assign({}, state), { data: action.payload.amoStatus });
        }
        case AMO_STATUS_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case AMO_STATUS_HIDE_ERROR_DATA:
            return Object.assign(Object.assign({}, state), { errorData: initState.errorData });
        case AMO_STATUS_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case AMO_STATUS_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default AMOStatus;
